export const COPYRIGHT = `\u00A9 ${new Date().getFullYear()}. AUTORUN Sp. z o.o. All rights reserved.`;
